import React from "react";
import "./Terms.css"; // reuses the same styling

function Privacy() {
  return (
    <div className="terms-wrapper">
      <div className="terms-container">
<h1>Privacy Policy</h1>
<p>Last Updated: January 2026</p>

<h2>1. Information We Collect</h2>
<p>
  EmployPilot collects only the minimum information required to operate
  the platform. This includes:
</p>
<ul>
  <li>Account information (email address, username, password — managed securely by Firebase)</li>
  <li>Optional profile data (username, state)</li>
  <li>User-generated content such as posts or resume inputs</li>
  <li>Analytics data (device type, usage events, crash reports)</li>
</ul>
<p>
  We do <strong>not</strong> collect sensitive information such as precise
  location, address, financial data, or government IDs.
</p>

<h2>2. How Your Data Is Used</h2>
<p>
  EmployPilot uses collected information strictly to:
</p>
<ul>
  <li>Provide core platform functionality, including AI features</li>
  <li>Manage user accounts and authentication</li>
  <li>Personalize the user experience</li>
  <li>Improve app performance and stability</li>
</ul>
<p>We do <strong>not</strong> sell or rent user data.</p>

<h2>3. Public vs. Private Information</h2>
<p>
  In the community section, only a user’s chosen <strong>username</strong>
  and <strong>state</strong> (if provided) are visible to others.
  Emails, real names, phone numbers, and Firebase IDs
  are <strong>never displayed</strong> publicly.
</p>

<h2>4. Data Security</h2>
<p>
  EmployPilot uses secure authentication, encryption, and industry-standard
  protections through Firebase and our hosting providers. Passwords are
  never stored in plain text.
</p>

<h2>5. Third-Party Services</h2>
<p>
  EmployPilot integrates with trusted third-party providers including:
</p>
<ul>
  <li>Firebase — authentication, analytics, crash reporting, cloud storage</li>
  <li>OpenAI — AI text generation</li>
  <li>Stripe — payments for EmployPilot Pro (if applicable)</li>
</ul>
<p>
  These services only process data needed to operate and improve the
  platform.
</p>

<h2>6. Your Choices & Data Rights</h2>
<p>
  Users may request account deletion or data removal at any time by emailing 
  <strong>support@employpilot.com</strong>. Deleted data cannot be recovered.
</p>

<h2>7. Children’s Privacy</h2>
<p>
  EmployPilot is not intended for users under 13. We do not knowingly collect
  information from children.
</p>

<h2>8. Changes to This Policy</h2>
<p>
  We may update this Privacy Policy to reflect new features or requirements.
  Continued use of the platform constitutes acceptance of any changes.
</p>

<h2>9. Contact</h2>
<p>
  For privacy questions or requests:<br />
  <strong>support@employpilot.com</strong>
</p>

<footer className="terms-footer">© 2025 EmployPilot. All Rights Reserved.</footer>

      </div>
    </div>
  );
}

export default Privacy;
